import EditorsSection from './DocEditTab/EditorsSection.jsx';
import DocEditSection from './DocEditTab/DocEditSection.jsx';
import RelationshipsSection from './DocEditTab/RelationshipsSection.jsx';
import TagSection from './DocEditTab/TagSection.jsx';
import ApiSection from './DocEditTab/ApiSection.jsx';
import ReconciliationSection from './DocEditTab/ReconciliationSection.jsx';


export default function DocEditTab(props) {
    let doc = props.doc;
    let docId = doc._id;
    let sendMessage = props.sendMessage;
    let children = props.children;
    let campaigns = props.campaigns;
    let apiKey = props.apiKey;
    let RegenerateApiKey = props.RegenerateApiKey;
    let RemoveApiKey = props.RemoveApiKey;

    return (
        <div>
            <EditorsSection
                sendMessage={sendMessage}
                doc={doc}
                />
            <hr />
            <DocEditSection
                sendMessage={sendMessage}
                doc={doc}
                />
            <hr />
            <RelationshipsSection
                sendMessage={sendMessage}
                doc={doc}
                children={children}
                campaigns={campaigns}
                />
            <hr />
            <TagSection
                sendMessage={sendMessage}
                doc={doc}
                />
            <hr />
            <ReconciliationSection
                sendMessage={sendMessage}
                doc={doc}
            />
            <hr />
            <ApiSection
                docId={docId}
                doc={doc}
                apiKey={apiKey}
                RegenerateApiKey={RegenerateApiKey}
                RemoveApiKey={RemoveApiKey}
                />
        </div>
    )
}